import prototype from '../src/lowcode/prototype';
import prototypeView from './prototypeView';
const bundle = {
    prototype,
    prototypeView,
};
export default bundle;
